import {
  PROFILE_LINK_PENDING,
  PROFILE_LINK_SUCCESS,
  PROFILE_LINK_ERROR,
} from "../action/profileLinkAction";

const initialState = {
  pending: false,
  profileLink: false,
  error: null,
};

const profileLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_LINK_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PROFILE_LINK_SUCCESS:
      return {
        ...state,
        pending: false,
        profileLink: action.payload,
      };
    case PROFILE_LINK_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
};
export default profileLinkReducer;
export const getProfileLinkSuccess = (state) => state.profileLink;
export const getProfileLinkPending = (state) => state.pending;
export const getProfileLinkError = (state) => state.error;
